import getOrganizationUsersQuery from "/public/graphQl/queries/getOrganizationUsers.js";

export const getOrganizationUsers = async ({commit, dispatch, rootState, rootGetters}) => {
    const selectedOrganizationId = rootGetters['app/getSelectedOrganizationId'];
    let currenciesData;

    try {
        if (!rootState.app.isLoading) {
            commit('app/setLoading', true, {root: true});
        }
        currenciesData = await dispatch('app/request', {
            type: 'query',
            gql: getOrganizationUsersQuery,
           variables: {
               organizationId: selectedOrganizationId,
           }
        }, {root: true});
    } catch (error) {
        return error;
    } finally {
        commit('app/setLoading', false, {root: true});
    }

    if (currenciesData.message) {
        throw currenciesData.message;
    }

    if (currenciesData.errors) {
        throw currenciesData.errors;
    }

    const {
        data: {
            getOrganizationUsers,
        },
    } = currenciesData;
    commit('setListUser', getOrganizationUsers);

    return true;
};
